import { render, staticRenderFns } from "./jdAddressList.vue?vue&type=template&id=58385e5f&scoped=true"
import script from "./jdAddressList.vue?vue&type=script&lang=js"
export * from "./jdAddressList.vue?vue&type=script&lang=js"
import style0 from "./jdAddressList.vue?vue&type=style&index=0&id=58385e5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58385e5f",
  null
  
)

export default component.exports